module.exports = __webpack_public_path__ + "img/bd.2fa0565c.svg";